import React from "react";
import { Row, Col } from "react-bootstrap";
import { Toggle } from "rsuite";

export default function Perspectives({
  values,
  onChange,
}: {
  values: any;
  onChange: any;
}) {
  return (
    <div className="mt-3 mb-3">
      <Row className="d-flex justify-content-around mb-3">
        <Col xs={12} md={4} className="d-flex justify-content-center">
          <div className="d-flex flex-column gap-3 justify-content-around ">
            <div className="text-right">
              <span>Habilitar Perspectivas</span>
            </div>
            <div className="d-flex justify-content-center">
              <Toggle
                checked={values.searchWithPerspectives}
                onChange={() =>
                  onChange({
                    target: {
                      name: "searchWithPerspectives",
                      value: !values.searchWithPerspectives,
                    },
                  })
                }
              />
            </div>
          </div>
        </Col>
      </Row>

      <Row className="d-flex justify-content-around mb-3">
        <Col xs={12} md={3} className="d-flex justify-content-center">
          <div className="d-flex flex-column gap-3">
            <div className="text-right">
              <span>Infancia</span>
            </div>
            <div className="d-flex justify-content-center">
              <Toggle
                checked={values.childhood}
                disabled={!values.searchWithPerspectives}
                onChange={() =>
                  onChange({
                    target: {
                      name: "childhood",
                      value: !values.childhood,
                    },
                  })
                }
              />
            </div>
          </div>
        </Col>

        <Col xs={12} md={3} className="d-flex justify-content-center">
          <div className="d-flex flex-column gap-3 justify-content-around">
            <div className="text-right">
              <span>Género</span>
            </div>
            <div className="d-flex justify-content-center">
              <Toggle
                checked={values.genre}
                disabled={!values.searchWithPerspectives}
                onChange={() =>
                  onChange({
                    target: {
                      name: "genre",
                      value: !values.genre,
                    },
                  })
                }
              />
            </div>
          </div>
        </Col>

        <Col xs={12} md={3} className="d-flex justify-content-center">
          <div className="d-flex flex-column gap-3 justify-content-around">
            <div className="text-right">
              <span>Relevancia</span>
            </div>
            <div className="d-flex justify-content-center">
              <Toggle
                checked={values.relevantCase}
                disabled={!values.searchWithPerspectives}
                onChange={() =>
                  onChange({
                    target: {
                      name: "relevantCase",
                      value: !values.relevantCase,
                    },
                  })
                }
              />
            </div>
          </div>
        </Col>
        <Col xs={12} md={3} className="d-flex justify-content-center">
          <div className="d-flex flex-column gap-3 justify-content-around">
            <div className="text-right">
              <span>Intercultural</span>
            </div>
            <div className="d-flex justify-content-center">
              <Toggle
                checked={values.intercultural}
                disabled={!values.searchWithPerspectives}
                onChange={() =>
                  onChange({
                    target: {
                      name: "intercultural",
                      value: !values.intercultural,
                    },
                  })
                }
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row className="d-flex justify-content-around">
        <Col xs={12} md={3} className="d-flex justify-content-center">
          <div className="d-flex flex-column gap-3">
            <div className="text-right">
              <span>Adulto mayor</span>
            </div>
            <div className="d-flex justify-content-center">
              <Toggle
                checked={values.olderPerson}
                disabled={!values.searchWithPerspectives}
                onChange={() =>
                  onChange({
                    target: {
                      name: "olderPerson",
                      value: !values.olderPerson,
                    },
                  })
                }
              />
            </div>
          </div>
        </Col>

        <Col xs={12} md={3} className="d-flex justify-content-center">
          <div className="d-flex flex-column gap-3 justify-content-around">
            <div className="text-right">
              <span>Persona con discapacidad</span>
            </div>
            <div className="d-flex justify-content-center">
              <Toggle
                checked={values.handicappedPerson}
                disabled={!values.searchWithPerspectives}
                onChange={() =>
                  onChange({
                    target: {
                      name: "handicappedPerson",
                      value: !values.handicappedPerson,
                    },
                  })
                }
              />
            </div>
          </div>
        </Col>

        <Col xs={12} md={3} className="d-flex justify-content-center">
          <div className="d-flex flex-column gap-3 justify-content-around">
            <div className="text-right">
              <span>Migrante</span>
            </div>
            <div className="d-flex justify-content-center">
              <Toggle
                checked={values.migrant}
                disabled={!values.searchWithPerspectives}
                onChange={() =>
                  onChange({
                    target: {
                      name: "migrant",
                      value: !values.migrant,
                    },
                  })
                }
              />
            </div>
          </div>
        </Col>
        <Col xs={12} md={3} className="d-flex justify-content-center">
          <div className="d-flex flex-column gap-3 justify-content-around">
            <div className="text-right">
              <span>Orientación , identidad y/o expresion sexual </span>
            </div>
            <div className="d-flex justify-content-center">
              <Toggle
                checked={values.sexual }
                disabled={!values.searchWithPerspectives}
                onChange={() =>
                  onChange({
                    target: {
                      name: "sexual",
                      value: !values.sexual ,
                    },
                  })
                }
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
